document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-ppc-carousel]').forEach(function (carousel) {

    var track = carousel.querySelector('[data-ppc-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var prevBtn = carousel.querySelector('[data-ppc-prev]');
    var nextBtn = carousel.querySelector('[data-ppc-next]');
    var section = carousel.closest('.ppc-mg');
    var dotsWrap = section ? section.querySelector('[data-ppc-dots]') : null;

    function getVisibleCount() {
      var styles = getComputedStyle(section);
      var w = window.innerWidth;

      if (w <= 749) {
        return parseInt(styles.getPropertyValue('--ppc-visible-mobile')) || 1;
      }

      if (w <= 989) {
        return parseInt(styles.getPropertyValue('--ppc-visible-tablet')) || 2;
      }

      return parseInt(styles.getPropertyValue('--ppc-visible-desktop')) || 4;
    }

    function slideWidth() {
      return slides[0].getBoundingClientRect().width + 20;
    }

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';

      var visible = getVisibleCount();
      var pages = Math.ceil(slides.length / visible);

      for (let i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ppc-mg__dot';

        dot.addEventListener('click', function () {
          track.scrollTo({
            left: i * visible * slideWidth(),
            behavior: 'smooth'
          });
        });

        dotsWrap.appendChild(dot);
      }

      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;

      var dots = dotsWrap.querySelectorAll('.ppc-mg__dot');
      var visible = getVisibleCount();

      var page = Math.round(track.scrollLeft / (visible * slideWidth()));

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === page);
      });
    }

    function updateArrows() {
      if (prevBtn) {
        prevBtn.disabled = track.scrollLeft <= 5;
      }

      if (nextBtn) {
        var maxScroll = track.scrollWidth - track.clientWidth;
        nextBtn.disabled = track.scrollLeft >= maxScroll - 5;
      }
    }

    function scrollByAmount(direction) {
      track.scrollBy({
        left: direction * getVisibleCount() * slideWidth(),
        behavior: 'smooth'
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByAmount(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByAmount(1);
      });
    }

    track.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        updateDots();
        updateArrows();
      });
    });

    window.addEventListener('resize', function () {
      buildDots();
      updateArrows();
    });

    buildDots();
    updateArrows();

    // ==========================
    // AUTOPLAY - moves one item at a time
    // ==========================

    var autoplay = carousel.hasAttribute('data-ppc-autoplay');
    var speed = (parseInt(section.dataset.autoplaySpeed, 10) || 4) * 1000;
    var autoplayTimer;

    function startAutoplay() {

      if (!autoplay) return;

      stopAutoplay();

      autoplayTimer = setInterval(function () {

        var maxScroll = track.scrollWidth - track.clientWidth;
        var oneSlide = slideWidth();
        var nextPosition = track.scrollLeft + oneSlide;

        if (nextPosition >= maxScroll - 2) {

          // Loop back to the first slide smoothly
          track.scrollTo({
            left: 0,
            behavior: 'smooth'
          });

        } else {

          track.scrollBy({
            left: oneSlide,
            behavior: 'smooth'
          });

        }

      }, speed);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    startAutoplay();

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

  });
});
